import React from 'react';
import { Col, Container, Row } from '@yme/atoms/grid';
import { Skeleton, GallerySkeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { AspectRatio } from '@yme/utils/constants';
export function AccessoriesGallerySkeleton() {
    const { isMobileView } = useWindowSize();
    return (React.createElement(Container, null,
        React.createElement(Row, { justifyContent: "flex-start" },
            React.createElement(Col, null,
                React.createElement(Skeleton, { skeletonProps: {
                        height: isMobileView ? 28 : 40,
                        width: isMobileView ? 200 : 400,
                    }, wrapperProps: {
                        mtS: 24,
                        mbS: 24,
                        mtL: 32,
                        mbL: 32,
                    } }))),
        React.createElement(Row, { justifyContent: "center" },
            React.createElement(Col, { lg: 8, md: 8 },
                React.createElement(GallerySkeleton, { aspectRatio: AspectRatio.RectangleLevel3 })))));
}
